// extracted by mini-css-extract-plugin
export default {"button":"ConnectWalletButton_button__KN-44","connectButton":"ConnectWalletButton_connectButton__41Ut1"};